import type { ReactNode } from 'react';
import { AuthProvider } from '@/contexts/AuthContext';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { NotificationsProvider } from '@/contexts/NotificationsContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { AppTourProvider } from '@/features/app-tour';

/**
 * Single provider tree — keeps one React context chain (avoids duplicate-module issues).
 * LanguageProvider must wrap any component that calls useLanguage (e.g. TopNavigation).
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <AuthProvider>
          <AppTourProvider>
            <NotificationsProvider>{children}</NotificationsProvider>
          </AppTourProvider>
        </AuthProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}
